var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { QuestionMarkCircleIcon } from '@marketing-icons';
import TooltipHandleSVG from '@svgs/funnel/TooltipHandlePolygon.svg';
import { clsx } from 'clsx';
import { useState } from 'react';
function Tooltip(_a) {
    var children = _a.children;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    return (_jsxs("div", __assign({ "aria-label": "Tooltip", onClick: function () { return setIsOpen(!isOpen); }, onMouseEnter: function () { return setIsOpen(true); }, onMouseLeave: function () { return setIsOpen(false); }, className: "w-5 cursor-pointer relative z-10" }, { children: [_jsx(QuestionMarkCircleIcon, { className: "hover:text-state-hover-shoe-website text-surface-black" }), _jsx("div", __assign({ className: clsx(isOpen ? 'block' : 'hidden', 'flex flex-col justify-start items-center') }, { children: _jsxs("div", __assign({ className: "absolute" }, { children: [_jsx("div", __assign({ className: "mb-[-1px]" }, { children: _jsx(TooltipHandleSVG, {}) })), _jsx("div", __assign({ className: "absolute w-64 top-full left-1/2 transform -translate-x-[60%] md:-translate-x-1/2 bg-surface-blue-dark text-text-white text-left px-4 py-3 rounded-sm text-sm-reg-m md:text-sm-reg-d" }, { children: children }))] })) }))] })));
}
export default Tooltip;
